import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { CostCenterEnums } from 'src/app/enum/cost-center-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { CostCenterImportModel } from 'src/app/models/imports/cost-center-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-cost-center',
  templateUrl: './import-cost-center.component.html',
  styleUrls: ['./import-cost-center.component.scss'],
  standalone: false
})
export class ImportCostCenterComponent {

  costCenterAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  costCenterImport: boolean = false;
  eventFile: any;
  errorCostCenter: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;

  constructor(
    private costCenterService: CostCenterService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.costCenterImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.costCenterService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaCCostos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.costCenterAlerts || this.costCenterAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar.'
      );
      return;
    }

    this.costCenterService.exportImportErrors(this.costCenterAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionCentrodeCostos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo.'
        );
      }
    });
  }

  importCostCenters() {
    this.costCenterAlerts = [];
    this.errorCostCenter = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<CostCenterImportModel>();
    let row: CostCenterImportModel;
    let counter: number = 1, branchCode: number, code: number, alterCode: string | null, name: string, costCenterTypeId: number,
      constructionSiteCode: number, priceListCode: number, swInvoiceM2: boolean, unitValueM2: number, swFixedQuota: boolean,
      valueFixedQuota: number, invoicingModelCode: number, ivaTypeId: number, administrationRate: number, incidentalRate: number,
      utilityRate: number, articleCode: number | null, conceptInvoicingCode: number | null, ratePromptPayment: number,
      observation: string | null;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {

      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de la sucursal no es válido.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //B. Código Centro Costos:
        code = parseFloat(element[1] as string);
        if (isNaN(code)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del centro costos no es válido.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //C. Código Alterno:
        alterCode = element[2] as string;
        if (alterCode != null) {
          if (alterCode.length > 10) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. El código alterno supera el tamaño máximo de caracteres (10).`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          }
        }

        //D. Nombre Obra:
        name = element[3] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El nombre no es válido`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El nombre supera el tamaño máximo de caracteres (70)`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //E. Tipo:
        if (element[4] as string != "T" && element[4] as string != "A" && element[4] as string != "P") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El tipo debe tener valores como: T / A / P.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }
        if (element[4] as string === "T") {
          costCenterTypeId = CostCenterEnums.TipoTercero;
        } else if (element[4] as string === "A") {
          costCenterTypeId = CostCenterEnums.TipoAdministración;
        } else {
          costCenterTypeId = CostCenterEnums.TipoPropio;
        }

        //F. Código Obra:
        constructionSiteCode = parseFloat(element[5] as string);
        if (isNaN(constructionSiteCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código de la obra no es válido.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //G. Código Lista Precios:
        priceListCode = parseFloat(element[6] as string);
        if (isNaN(priceListCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El código de la lista de precios no es válido.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //H. Factura M2:
        if (element[7] as string != "S" && element[7] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El campo factura M2 debe tener valores como: S / N.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }
        swInvoiceM2 = element[7] as string === "S";

        //I. Valor Unitario M2:
        unitValueM2 = parseFloat(element[8] as string);
        if (isNaN(unitValueM2)) {
          if (swInvoiceM2) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. El valor unitario M2 no es válido.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
            return;
          } else {
            unitValueM2 = 0;
          }
        }

        //J. Cuota Fija:
        if (element[9] as string != "S" && element[9] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. El campo cuota fija debe ser valores como: S / N.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }
        swFixedQuota = element[9] as string === "S";

        //K. Valor Unitario Cuota Fija:
        valueFixedQuota = parseFloat(element[10] as string);
        if (isNaN(valueFixedQuota)) {
          if (swFixedQuota) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna K. El valor unitario cuota fija no es válido.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            valueFixedQuota = 0;
          }
        }

        //L. Modelo de Factura:
        invoicingModelCode = parseFloat(element[11] as string);
        if (isNaN(invoicingModelCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna L. El código del modelo de facturación no es válido.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }

        //M. Tipo de Iva:
        if (element[12] as string != "P" && element[12] as string != "S") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. El tipo de Iva debe ser valores como: P / S.`;
          this.costCenterAlerts.push(alert);
          rowHasError = true;
        }
        ivaTypeId = element[12] as string === "P" ? IvaTypeEnums.pleno : IvaTypeEnums.sobreUtilidad;

        //N. Tarifa Administración:
        administrationRate = parseFloat(element[13] as string);
        if (isNaN(administrationRate)) {
          if (ivaTypeId == IvaTypeEnums.sobreUtilidad) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna N. La tarifa de administración no es válida.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            administrationRate = 0;
          }
        }

        //O. Tarifa Imprevistos:
        incidentalRate = parseFloat(element[14] as string);
        if (isNaN(incidentalRate)) {
          if (ivaTypeId == IvaTypeEnums.sobreUtilidad) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna O. La tarifa de imprevistos no es válida.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            incidentalRate = 0;
          }
        }

        //P. Tarifa Utilidad:
        utilityRate = parseFloat(element[15] as string);
        if (isNaN(utilityRate)) {
          if (ivaTypeId == IvaTypeEnums.sobreUtilidad) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna P. La tarifa de utilidad no es válida.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            utilityRate = 0;
          }
        }

        //Q. Artículo AIU:
        articleCode = parseFloat(element[16] as string);
        if (isNaN(articleCode)) {
          if (ivaTypeId == IvaTypeEnums.sobreUtilidad) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna Q. El código del artículo AIU no es válido.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            articleCode = null;
          }
        }

        //R. Concepto de Facturación AIU:
        conceptInvoicingCode = parseFloat(element[17] as string);
        if (isNaN(conceptInvoicingCode)) {
          if (ivaTypeId == IvaTypeEnums.sobreUtilidad) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna R. El código del concepto de facturación AIU no es válido.`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          } else {
            conceptInvoicingCode = null;
          }
        }

        //S. Tarifa Pronto-Pago:
        ratePromptPayment = parseFloat(element[18] as string);
        if (isNaN(ratePromptPayment)) {
          ratePromptPayment = 0;
        }

        //T. Observación:
        observation = element[19] as string;
        if (observation != null) {
          if (observation.length > 250) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna T. La observación supera el tamaño máximo de caracteres (250).`;
            this.costCenterAlerts.push(alert);
            rowHasError = true;
          }
        }

        if (!rowHasError) {
          row = new CostCenterImportModel(counter, branchCode, code, alterCode, name, costCenterTypeId, constructionSiteCode, priceListCode,
            swInvoiceM2, unitValueM2, swFixedQuota, valueFixedQuota, invoicingModelCode, ivaTypeId, administrationRate, incidentalRate,
            utilityRate, articleCode, conceptInvoicingCode, ratePromptPayment, observation);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorCostCenter = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportCostCenters(rowsImports);
    });
  }

  async processImportCostCenters(rowsImports: Array<CostCenterImportModel>) {
    try {
      const response = await firstValueFrom(this.costCenterService.importCostCenters(rowsImports));
      this.loadPreInvoicingModel = response;
      this.costCenterAlerts = response?.alerts ?? [];
      this.errorCostCenter = response?.preInvoicingStateId;
      if (this.errorCostCenter === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.costCenterAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.costCenterImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Centros de Costos.', error);
    }
  }
}
